import styled from 'styled-components';

export const Text = styled.div`
	margin-top: 4px;
	font-size: 16px;
	line-height: 22px;
	color: rgba(9, 21, 38, 0.6);
`;

export const ChartTitle = styled.h3`
	font-weight: bold;
	font-size: 20px;
	line-height: 28px;
	color: rgba(9, 21, 38, 0.85);
`;
